import {
  CLIENT_LOADED_AT_HEADER,
  CLIENT_VERSION_HEADER,
} from "@redotech/redo-common-model/headers/client-version-field";
import { REDO_MERCHANT_APP_VERSION } from "./config";

// Module load == page load, so this captures when the tab first loaded.
const CLIENT_LOADED_AT_MS = String(Date.now());

// Spread into every merchant RPC client's headers so the server can detect
// outdated tabs and how long they've been open.
export const clientVersionHeaders: Record<string, string> = {
  [CLIENT_VERSION_HEADER]: REDO_MERCHANT_APP_VERSION,
  [CLIENT_LOADED_AT_HEADER]: CLIENT_LOADED_AT_MS,
};
